import React from "react";
import { Item, BoxItem } from "../types";

interface SelectedItemsListProps {
  boxItems: BoxItem[];
  getItemById: (id: string) => Item | undefined;
  onItemRemove: (itemId: string) => void;
}

const SelectedItemsList: React.FC<SelectedItemsListProps> = ({
  boxItems,
  getItemById,
  onItemRemove,
}) => {
  if (boxItems.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Geselecteerde items
        </h2>
        <p className="text-gray-500 text-center py-4">
          Nog geen items geselecteerd
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">
          Geselecteerde items ({boxItems.length})
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {boxItems.map((boxItem) => {
            const item = getItemById(boxItem.itemId);
            if (!item) return null;

            return (
              <div
                key={`${boxItem.itemId}-${boxItem.boxIndex}`}
                className="flex items-center p-3 border border-gray-200 rounded-lg hover:bg-gray-50"
              >
                <div className="flex-shrink-0">
                  <img
                    src={item.thumbnail}
                    alt={item.name}
                    className="w-10 h-10 rounded object-cover"
                  />
                </div>
                <div className="ml-3 flex-1">
                  <h3 className="text-sm font-medium text-gray-900">
                    {item.name}
                  </h3>
                  <p className="text-xs text-gray-500">Kleur: {item.color}</p>
                  <p className="text-xs text-gray-500">
                    Vak: {boxItem.boxIndex + 1}
                  </p>
                </div>
                <button
                  onClick={() => onItemRemove(boxItem.itemId)}
                  className="flex-shrink-0 ml-2 p-1 text-red-600 hover:text-red-800 hover:bg-red-50 rounded transition-colors"
                  title="Verwijder item"
                >
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SelectedItemsList;
